// Challenges quiz fields persist their `view.fieldType` / platformized
// `identifier` as `QUIZ_*` (see CHALLENGES_FIELD_TYPES in form-fields). Unlike
// the native `PLATFORM_QUIZ_*` fields, their quiz answer data does NOT live in
// the field `view`; it lives in the form's `@achievements/quizzes`
// data-extensions namespace, keyed by `fieldId`.
export const QUIZZES_EXTENDED_FIELDS_NAMESPACE = '@achievements/quizzes';
export const CHALLENGES_FIELD_TYPES = [
    'QUIZ_SHORT_TEXT',
    'QUIZ_LONG_TEXT',
    'QUIZ_SINGLE_CHOICE',
    'QUIZ_MULTI_CHOICE',
    'QUIZ_IMAGE_CHOICE',
    'QUIZ_NUMBER',
    'QUIZ_FILE_UPLOAD'
];
const CHALLENGES_FIELD_TYPE_SET = new Set(CHALLENGES_FIELD_TYPES);
export function isChallengesFieldType(identifier) {
    return identifier != null && CHALLENGES_FIELD_TYPE_SET.has(identifier);
}
export const DEFAULT_QUIZ_SCORE = 1;

//# sourceMappingURL=quiz-fields.js.map